/*
 * The PrepAnywhere mark: blue disc, white double chevron.
 * Paths lifted verbatim from src/assets/images/full_logo.svg so this stays the
 * real brand mark. It keeps its own blue (#4098F9) rather than the page accent.
 */
const LogoMark = ({ size = 28, className }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 35 35"
        role="img"
        aria-label="PrepAnywhere"
    >
        <ellipse cx="17.5" cy="17.5" rx="17.5" ry="17.5" fill="#4098F9" />
        <path d="M20.7,11.1h-4.1l4.6,6.4l-4.6,6.4h4.1l4.6-6.4L20.7,11.1z" fill="#FFFFFF" />
        <path d="M14.3,11.1h-4.1l4.6,6.4l-4.6,6.4h4.1l4.6-6.4L14.3,11.1z" fill="#FFFFFF" />
    </svg>
);

export default LogoMark;
